export const CampaignsSlug = {
    list: 'aktionen',
    detail: ':/slug',
} as const;

export function getCampaignsUrl(dealerslug: string): string {
    return `/${dealerslug}/${CampaignsSlug.list}`;
}

export function getCampaignsDetailUrl(dealerslug: string, campaignSlug: string): string {
    return `/${dealerslug}/${CampaignsSlug.list}/${campaignSlug}`;
}
